import { FieldValues } from 'features/libra/ontology/ontologyFieldTypes'
import { Condition } from 'features/libra/sections/formLayout'
import { evaluateCondition } from 'features/libra/stepComponents/conditionalForm/conditions/evaluateConditionalFormCondition'

export const getVisibleSectionIds = (
  form: ReadonlyArray<{
    sectionId: string
    showWhen: ReadonlyArray<Condition>
  }>,
  fieldValues: FieldValues
): ReadonlyArray<string> => {
  return form
    .filter(({ showWhen }) =>
      showWhen.every((condition) => evaluateCondition(condition, fieldValues))
    )
    .map(({ sectionId }) => sectionId)
}
